import { formatDateTime } from 'utils/dates/date.utils';
import styles from './AlertDetails.module.css';

const AlertDetails = ({ alert }) => {
  const isUserGeneratedAlert = Boolean(alert.workplaceId || alert.globalActionId);
  const authoredSummaryLines = isUserGeneratedAlert
    ? String(alert.smpp_message ?? '')
        .split(';')
        .filter((alertMessageLine) => alertMessageLine && !alertMessageLine.includes('till:'))
    : [];

  return (
    <div className={`${styles.content} pe-3`}>
      <div>
        <div className="my-2 fs-5 fw-bold">
          <div className="fs-5">{alert.description}</div>
          <div className="fs-5">Until: {formatDateTime(alert.valid_until_time_utc)}</div>
          {authoredSummaryLines.map((alertMessageLine, index) => (
            <div key={index} className="fs-6">
              {alertMessageLine}
            </div>
          ))}
        </div>
        <div className={`${styles.message} mb-3 fs-6`}>
          {String(alert.message ?? '')
            .split('*')
            .filter(Boolean)
            .map((alertMessageLine, index) => (
              <p key={index} className="mb-1">
                {alertMessageLine.trim()}
              </p>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AlertDetails;
